// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.decorations {
  overflow-x: hidden;
}

.decorations .heroSkeleton,
.decorations .hero {
  margin-top: unset !important;
}

.decorations__container {
  display: flex;
  align-items: center;
  flex-direction: column-reverse;
  padding-bottom: 5em;
}

.decorations__container > div {
  max-width: 37rem;
  margin-top: -4rem;
}

.decorations__title {
  display: flex;
  flex-direction: column;
  font-size: 2rem;
  color: var(--clr-gray800);
}

.decorations__title em {
  color: var(--clr-primary);
  font-size: 1.25rem;
  margin-top: 0.5rem;
}

.decorations__description {
  line-height: 1.8;
  margin: 2rem 0;
}

.decorations__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 1em;
}

.decorations__btn svg {
  width: 2rem;
  margin-right: 0.5rem;
}

.decorations__imgContainer {
  display: flex;
  position: relative;
}

.decorations__imgContainer::before {
  content: "";
  /* background: ; */
  position: absolute;
  /* background: black; */
  height: 100%;
  width: 50%;
  z-index: 4;
  right: 0;
  background: linear-gradient(270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);
}

.decorations__imageSection {
  position: relative;
  max-width: 37rem;
  transform: scale(0.5);
}

.decorations__imgContainerArrow {
  position: absolute;
  z-index: 4;
  right: 2.5rem;
  top: 50%;
  transform: translateY(-50%);
}

.decorations__imgContainerArrow svg {
  width: 5rem;
  cursor: pointer;
}

.decorations__img {
  /* flex: 1 1 50%; */
  position: relative;
  object-fit: cover;
  width: 28rem;
  height: 28rem;
  border-radius: 1em;
  flex-shrink: 0;
}

.decorations__img:nth-of-type(1) {
  z-index: 4;
}

.decorations__img:nth-of-type(2) {
  left: -65%;
  z-index: 3;
  opacity: 0.8;
  transform: scale(0.9);
}
.decorations__img:nth-of-type(3) {
  left: calc(-65% - 65%);
  z-index: 2;
  opacity: 0.7;
  transform: scale(0.8);
}
.decorations__img:nth-of-type(4) {
  left: calc(-65% - 65% - 65%);
  z-index: 1;
  opacity: 0.6;
  transform: scale(0.7);
}

.decorations__img:nth-of-type(n + 5) {
  display: none;
}

.decorations__btn .arrow {
  width: 1.5rem;
  margin-left: 1rem;
}

.decorations__note {
  display: block;
  margin-top: 0.5rem;
  font-weight: bold;
}

@media (min-width: 425px) {
  .decorations__container > div {
    margin-top: -2rem;
  }

  .decorations__imageSection {
    transform: scale(0.65);
  }
}
@media (min-width: 475px) {
  .decorations__container > div {
    margin-top: -1rem;
  }

  .decorations__imageSection {
    transform: scale(0.7);
  }
}
@media (min-width: 500px) {
  .decorations__imageSection {
    transform: scale(0.75);
  }

  .decorations__btn svg {
    width: 1.25rem;
  }
}
@media (min-width: 600px) {
  .decorations__container > div {
    margin-top: 1rem;
  }

  .decorations__imageSection {
    transform: scale(0.85);
  }
}

@media (min-width: 768px) {
  .decorations__container > div {
    margin-top: 4rem;
  }

  .decorations__container .decorations__content {
    width: 100%;
    max-width: unset;
  }
  .decorations__title {
    /* align-items: flex-end; */
    width: max-content;
    font-size: 2.5rem;
    white-space: nowrap;
  }

  .decorations__title em {
    font-size: 1.8rem;
  }

  .decorations__imageSection {
    transform: scale(1);
  }
}

@media (min-width: 992px) {
  .decorations {
    overflow-x: unset;
  }

  .decorations__container {
    display: flex;
    align-items: center;
    padding: 5em 0;
    gap: 2rem;
    justify-content: space-between;
  }

  .decorations__container > div {
    flex: 1 1 50%;
    margin-top: 0;
  }
  .decorations__title {
    align-items: flex-end;
    width: max-content;
    font-size: 2rem;
    white-space: unset;
  }

  .decorations__title em {
    /* align-items: flex-end; */
    font-size: 1.5rem;
  }

  .decorations__container .decorations__content {
    max-width: 25rem;
    /* max-width: 37rem; */
  }

  .decorations__container {
    flex-direction: row;
    /* padding: 5em 0; */
    gap: 2rem;
    padding-bottom: 5em;
    /* gap: 5rem; */
  }

  .decorations__imageSection {
    transform: scale(0.8);
  }
}

@media (min-width: 1200px) {
  .decorations__container {
    gap: 5rem;
  }

  .decorations__container .decorations__content {
    max-width: 37rem;
  }

  .decorations__title {
    font-size: 2.5rem;
    white-space: nowrap;
  }

  .decorations__title em {
    font-size: 1.8rem;
  }

  .decorations__imageSection {
    transform: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Decorations/Decorations.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,QAAQ;EACR,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".decorations {\n  overflow-x: hidden;\n}\n\n.decorations .heroSkeleton,\n.decorations .hero {\n  margin-top: unset !important;\n}\n\n.decorations__container {\n  display: flex;\n  align-items: center;\n  flex-direction: column-reverse;\n  padding-bottom: 5em;\n}\n\n.decorations__container > div {\n  max-width: 37rem;\n  margin-top: -4rem;\n}\n\n.decorations__title {\n  display: flex;\n  flex-direction: column;\n  font-size: 2rem;\n  color: var(--clr-gray800);\n}\n\n.decorations__title em {\n  color: var(--clr-primary);\n  font-size: 1.25rem;\n  margin-top: 0.5rem;\n}\n\n.decorations__description {\n  line-height: 1.8;\n  margin: 2rem 0;\n}\n\n.decorations__btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border-radius: 1em;\n}\n\n.decorations__btn svg {\n  width: 2rem;\n  margin-right: 0.5rem;\n}\n\n.decorations__imgContainer {\n  display: flex;\n  position: relative;\n}\n\n.decorations__imgContainer::before {\n  content: \"\";\n  /* background: ; */\n  position: absolute;\n  /* background: black; */\n  height: 100%;\n  width: 50%;\n  z-index: 4;\n  right: 0;\n  background: linear-gradient(270deg, #fcfbf9 0%, rgba(247, 247, 252, 0) 100%);\n}\n\n.decorations__imageSection {\n  position: relative;\n  max-width: 37rem;\n  transform: scale(0.5);\n}\n\n.decorations__imgContainerArrow {\n  position: absolute;\n  z-index: 4;\n  right: 2.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.decorations__imgContainerArrow svg {\n  width: 5rem;\n  cursor: pointer;\n}\n\n.decorations__img {\n  /* flex: 1 1 50%; */\n  position: relative;\n  object-fit: cover;\n  width: 28rem;\n  height: 28rem;\n  border-radius: 1em;\n  flex-shrink: 0;\n}\n\n.decorations__img:nth-of-type(1) {\n  z-index: 4;\n}\n\n.decorations__img:nth-of-type(2) {\n  left: -65%;\n  z-index: 3;\n  opacity: 0.8;\n  transform: scale(0.9);\n}\n.decorations__img:nth-of-type(3) {\n  left: calc(-65% - 65%);\n  z-index: 2;\n  opacity: 0.7;\n  transform: scale(0.8);\n}\n.decorations__img:nth-of-type(4) {\n  left: calc(-65% - 65% - 65%);\n  z-index: 1;\n  opacity: 0.6;\n  transform: scale(0.7);\n}\n\n.decorations__img:nth-of-type(n + 5) {\n  display: none;\n}\n\n.decorations__btn .arrow {\n  width: 1.5rem;\n  margin-left: 1rem;\n}\n\n.decorations__note {\n  display: block;\n  margin-top: 0.5rem;\n  font-weight: bold;\n}\n\n@media (min-width: 425px) {\n  .decorations__container > div {\n    margin-top: -2rem;\n  }\n\n  .decorations__imageSection {\n    transform: scale(0.65);\n  }\n}\n@media (min-width: 475px) {\n  .decorations__container > div {\n    margin-top: -1rem;\n  }\n\n  .decorations__imageSection {\n    transform: scale(0.7);\n  }\n}\n@media (min-width: 500px) {\n  .decorations__imageSection {\n    transform: scale(0.75);\n  }\n\n  .decorations__btn svg {\n    width: 1.25rem;\n  }\n}\n@media (min-width: 600px) {\n  .decorations__container > div {\n    margin-top: 1rem;\n  }\n\n  .decorations__imageSection {\n    transform: scale(0.85);\n  }\n}\n\n@media (min-width: 768px) {\n  .decorations__container > div {\n    margin-top: 4rem;\n  }\n\n  .decorations__container .decorations__content {\n    width: 100%;\n    max-width: unset;\n  }\n  .decorations__title {\n    /* align-items: flex-end; */\n    width: max-content;\n    font-size: 2.5rem;\n    white-space: nowrap;\n  }\n\n  .decorations__title em {\n    font-size: 1.8rem;\n  }\n\n  .decorations__imageSection {\n    transform: scale(1);\n  }\n}\n\n@media (min-width: 992px) {\n  .decorations {\n    overflow-x: unset;\n  }\n\n  .decorations__container {\n    display: flex;\n    align-items: center;\n    padding: 5em 0;\n    gap: 2rem;\n    justify-content: space-between;\n  }\n\n  .decorations__container > div {\n    flex: 1 1 50%;\n    margin-top: 0;\n  }\n  .decorations__title {\n    align-items: flex-end;\n    width: max-content;\n    font-size: 2rem;\n    white-space: unset;\n  }\n\n  .decorations__title em {\n    /* align-items: flex-end; */\n    font-size: 1.5rem;\n  }\n\n  .decorations__container .decorations__content {\n    max-width: 25rem;\n    /* max-width: 37rem; */\n  }\n\n  .decorations__container {\n    flex-direction: row;\n    /* padding: 5em 0; */\n    gap: 2rem;\n    padding-bottom: 5em;\n    /* gap: 5rem; */\n  }\n\n  .decorations__imageSection {\n    transform: scale(0.8);\n  }\n}\n\n@media (min-width: 1200px) {\n  .decorations__container {\n    gap: 5rem;\n  }\n\n  .decorations__container .decorations__content {\n    max-width: 37rem;\n  }\n\n  .decorations__title {\n    font-size: 2.5rem;\n    white-space: nowrap;\n  }\n\n  .decorations__title em {\n    font-size: 1.8rem;\n  }\n\n  .decorations__imageSection {\n    transform: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
